import { Goal, Task, TaskType, Timestamp } from '@griply/types';

export const getTaskDeadline = (
  task: Task,
  actionGoal: Goal | undefined,
): Timestamp | null => {
  if (actionGoal?.deadline) {
    return actionGoal.deadline;
  }
  if (task.type !== TaskType.Task) {
    return null;
  }
  return task.deadlineDeadline ?? null;
};
